import { useMutation } from 'react-query'
import { useHistory } from 'react-router-dom'
import { AvailyEvent } from '@customTypes/Availy'
import routes from 'src/config/routes'
import { completedContactForm } from 'src/services/analytics'
import { createBookingForNewPatient } from 'src/services/api/booking'
import { getAfterBookingStateFromBookingResponse } from 'src/utils/getAfterBookingStateFromBookingResponse'
import { postParentMsg } from 'src/utils/postMessage'
import prepareSuccessUrl from 'src/utils/prepareSuccessUrl'
import { useChoiceState } from '@context/ChoiceContext'
import { setAfterBookingData, useConfig, useConfigDispatch } from '@context/ConfigurationContext'
import logToPostHog from 'src/helpers/logToPosthog'
import { useClinicOfficialName } from './useClinicOfficialName'
import { getErrorTranslationKey } from 'src/helpers/getApiErrorTranslationKey'

export const useCreateBookingForNewPatient = (onRequestError?: (error: string) => void) => {
  const choices = useChoiceState()
  const config = useConfig()
  const configDispatch = useConfigDispatch()
  const { successUrl: configuredSuccessUrl, embedded } = config
  const history = useHistory()
  const nearbyClinicName = useClinicOfficialName(choices.selectedBookableDateAndTime.clinicId)
  const baseClinicName = useClinicOfficialName(config.clinicId)

  return useMutation(createBookingForNewPatient, {
    onSuccess: async (result) => {
      if (choices.selectedBookableDateAndTime.clinicId !== config.clinicId)
        logToPostHog('Nearby timeslot booked', { nearbyClinic: nearbyClinicName, baseClinic: baseClinicName })

      completedContactForm()

      const linkToAna = result?.data?.anamnesisLink

      configDispatch(setAfterBookingData(getAfterBookingStateFromBookingResponse(result?.data)))
      if (configuredSuccessUrl && !linkToAna) {
        const sucessUrl = await prepareSuccessUrl(configuredSuccessUrl, choices)
        if (!embedded) {
          return setTimeout(() => {
            window.location.href = sucessUrl
          }, 1000)
        }

        postParentMsg({
          type: AvailyEvent.BOOKING_CREATED,
          payload: sucessUrl,
        })
      } else {
        history.push(routes.success)
      }
    },
    onError: (err: Record<string, any>) => {
      onRequestError?.(getErrorTranslationKey(err))
    },
    retry: 0,
  })
}
